export const POSTER_EDITOR_CROP_PANEL_ID = 'poster-editor-crop-panel';

export interface PosterEditorCropPanelProps {
  panelId: string;
}

/** Preset label colours on the sheet: the selected one in the brand colour, the rest neutral. */
export const CROP_PRESET_SELECTED_TEXT_CLASS = 'ct-brand-primary';
export const CROP_PRESET_TEXT_CLASS = 'ct-neutral-primary';
